<template>
  <div class="mt-4 flex p-2 sm:p-8">
    <vx-card title="Términos y condiciones">
      <span v-html="terms"/>
    </vx-card>
  </div>

</template>

<script>

export default {
  computed: {
    terms() {
      return this.$store.getters['getParameter']('general').serviceTerms;
    }
  }
}
</script>

<style scoped>

</style>
